interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: "Posso cancelar minha assinatura a qualquer momento?",
    answer:
      "Sim, você pode cancelar sua assinatura quando quiser. Não há contratos de longo prazo ou taxas de cancelamento."
  },
  {
    question: "Como funciona o limite de mensagens no Chat de Questões?",
    answer:
      "No plano gratuito, você pode enviar até 5 mensagens por dia. Com o Vstiba Total, esse limite aumenta para 100 mensagens diárias."
  },
  {
    question: "O que é o Modo Prova?",
    answer:
      "O Modo Prova simula as condições reais do ENEM e vestibulares, com tempo limitado e sem visualização das respostas antes do término."
  }
];

export default function FAQ(): JSX.Element {
  return (
    <div className="mt-16">
      <h3 className="mb-8 text-center text-2xl font-bold">
        Perguntas Frequentes
      </h3>
      <div className="space-y-4">
        {faqItems.map((faq, index) => (
          <div
            key={index}
            className="p-6 bg-white border border-gray-100 rounded-xl shadow-sm"
          >
            <h4 className="mb-2 text-emphasis-high font-semibold">
              {faq.question}
            </h4>
            <p className="text-emphasis-low">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
